// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { useEffect, useRef } from 'react';
import { getCurrentSymbol, calculatePrice, PriceDisplay } from '../../../Helpers/Helpers';
import ProductMobileOverlay from './ProductMobileOverlay';
import { UseWindowDimensions } from '../../collage/utils';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import SpecialProductMobileOverlay from './SpecialProductMobileOverlay';
import LazyImage from '../../LazyImage';
import { FiExternalLink } from 'react-icons/fi';
import PostRating from '../../PostRating';

export default function ProductsOverlay({ row, shopifyData, albumData, activeIndex }: any) {
  const btnOneRef = useRef([]);
  const btnTwoRef = useRef([]);

  useEffect(() => {
    if (row?.products?.length > 0) {
      row.products.forEach((_, index) => {
        if (!btnOneRef.current[index]) {
          btnOneRef.current[index] = React.createRef();
        }
        if (!btnTwoRef.current[index]) {
          btnTwoRef.current[index] = React.createRef();
        }
      });
    }
  }, [row?.products]);

  const { data, setProductOverlayIndex, isWooCommerceSite, layout, isOpen, clickMutate } = useDisplayWidgetContext();
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const { width } = UseWindowDimensions();

  useEffect(() => {
    if (!isOpen) {
      setSelectedProduct(null);
    }
  }, [isOpen]);
  return (
    <React.Fragment>
      <style>
        {`.zid_overlay_container .swiper {
        max-width: 100%;
        }`}
      </style>
      <idk-div class="zid_overlay_container zid-absolute zid-left-0 zid-bottom-0 zid-w-full zid-p-0 zid-border zid-border-transparent">
        <Swiper
          modules={[Autoplay]}
          autoplay={true}
          centeredSlides={true}
          slidesPerView={1}
          loop={row?.products?.length > 1 ? true : false}
          pagination={false}
        >
          {row?.products?.length > 0 &&
            row.products.map((product, index) => {
              if (!btnOneRef.current[index]) {
                btnOneRef.current[index] = React.createRef();
              }
              if (!btnTwoRef.current[index]) {
                btnTwoRef.current[index] = React.createRef();
              }
              return (
                <SwiperSlide key={index}>
                  <idk-div
                    style={{
                      backgroundColor: `${layout?.productsSettings?.postOverlayColor}cc` || '#000000',
                      color: layout?.productsSettings?.postOverlayTextColor || '#ffffff',
                      backGroundOpacity: '50%',
                      width: '100%',
                    }}
                    class="zid-relative zid-flex zid-bg-black zid-bg-opacity-70 zid-text-white zid-w-full zid-h-24 zid-cursor-pointer zid-items-center zid-p-2"
                    onClick={() => {
                      // if (row?.products?.length > 1) {
                      //   setSelectedProduct(product);
                      //   setProductOverlayIndex(index);
                      // }
                    }}
                  >
                    <LazyImage
                      onClick={() => {
                        window.open(
                          shopifyData
                            ? `https://${window.location.host}/products/${product?.handle}`
                            : `${product?.product_url}?utm_source=${
                                layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                              }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                              }`,
                          '_blank',
                        );
                      }}
                      src={
                        product?.images?.[0]?.image_url?.replaceAll('resize/800x800', 'resize/64x64') ||
                        product?.images?.[0]?.replaceAll('resize/800x800', 'resize/64x64')
                      }
                      className="zid-h-full zid-object-contain zid-bg-white zid-rounded"
                      style={{ maxWidth: '80px', maxHeight: '80px', flex: '0 0 80px' }}
                      loading="lazy"
                      alt={product?.title}
                    ></LazyImage>

                    <idk-div class="zid-flex zid-flex-col zid-justify-between zid-p-2 zid-h-24 zid-w-full">
                      <idk-div class="zid-flex zid-gap-1 zid-justify-between">
                        <idk-span
                          class="zid-text-ellipsis zid-overflow-hidden zid-text-base "
                          style={{
                            display: '-webkit-box',
                            WebkitLineClamp: '2',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            fontWeight: 500,
                            lineHeight: '18px',
                          }}
                          onClick={() => {
                            window.open(
                              shopifyData
                                ? `https://${window.location.host}/products/${product?.handle}`
                                : `${product?.product_url}?utm_source=${
                                    layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                  }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                    layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                  }`,
                              '_blank',
                            );
                          }}
                        >
                          {product?.title}{' '}
                        </idk-span>
                        {layout?.popupSettings?.showPostDescription == false && (
                          <a
                            className=""
                            target="_blank"
                            href={
                              shopifyData
                                ? `https://${window.location.host}/products/${product?.handle}`
                                : product?.product_url
                            }
                          >
                            <FiExternalLink color="#fff" fontSize={20} />
                          </a>
                        )}
                      </idk-div>
                      {layout?.productsSettings?.showProductRating && product?.productReview && (
                        <PostRating
                          rating={
                            product?.productReview?.ProductStatistics?.ReviewStatistics?.AverageOverallRating || 0
                          }
                          totalUsers={
                            product?.productReview?.ProductStatistics?.ReviewStatistics?.TotalReviewCount || 0
                          }
                          color={layout?.productsSettings?.productRatingStarColor}
                          url={
                            layout?.productsSettings?.productRatingUrl
                              ? layout?.productsSettings?.productRatingUrl
                              : shopifyData
                              ? `https://${window.location.host}/products/${product?.handle}`
                              : `${product?.product_url}?utm_source=${
                                  layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                }&utm_medium=${layout?.gallerySettings?.utmMedium || 'StarRating'}&utm_campaign=${
                                  layout?.gallerySettings?.utmCampaign || 'ShoppableVideos'
                                }`
                          }
                        />
                      )}
                      <idk-div class="zid-flex zid-justify-between zid-items-center">
                        <idk-div class="zid-flex zid-justify-between">
                          <idk-div class="zid-flex zid-gap-2">
                            <idk-div class="zid-font-bold">
                              {isWooCommerceSite() &&
                                !data.result.currency &&
                                document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]?.innerHTML}
                              {shopifyData?.currency?.active &&
                                getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                              {shopifyData ? (
                                calculatePrice(
                                  parseFloat(product?.variants?.[0]?.price) / 100,
                                  parseFloat(shopifyData?.currency?.rate),
                                )
                              ) : (
                                <PriceDisplay
                                  price={product?.variants?.[0]?.price}
                                  salePrice={product?.variants?.[0]?.salePrice}
                                  currency={data.result.currency}
                                />
                              )}
                            </idk-div>
                            {shopifyData && product?.variants?.[0]?.compare_at_price > product?.variants?.[0]?.price && (
                              <idk-div>
                                <del className="zid-me-2 zid-text-red-400	zid-text-base">
                                  {data.result.currency &&
                                    getCurrentSymbol(
                                      data.result.currency,
                                      navigator?.language || navigator['userLanguage'],
                                    )}
                                  {isWooCommerceSite() &&
                                    !data.result.currency &&
                                    document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                      ?.innerHTML}
                                  {shopifyData?.currency?.active &&
                                    !data.result.currency &&
                                    getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                  {parseFloat(product?.variants?.[0]?.compare_at_price) / 100}
                                </del>
                              </idk-div>
                            )}
                          </idk-div>
                        </idk-div>
                        <idk-div>
                          {layout?.productsSettings?.shopBtnPosition == 'absolute' && (
                            <button
                              ref={btnOneRef.current[index]}
                              onClick={() => {
                                clickMutate(row.id, {
                                  event: 'add_to_cart',
                                  price: product?.variants?.[0]?.salePrice,
                                  productId: product?.id_from_product,
                                });
                                const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                if (shopBtnFunctionality) {
                                  try {
                                    const func = new Function(
                                      'postData',
                                      'productData',
                                      'current',
                                      shopBtnFunctionality,
                                    );
                                    func(row, product, btnOneRef.current[index]);
                                  } catch (error) {
                                    console.error('Error executing shopBtnFunctionality', error);
                                  }
                                } else {
                                  if (row?.product.length == 1) {
                                    window.open(
                                      shopifyData
                                        ? `https://${window.location.host}/products/${product?.handle}`
                                        : `${product?.product_url}?utm_source=${
                                            layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                          }&utm_medium=${
                                            layout?.gallerySettings?.utmMedium || 'AddToCart'
                                          }&utm_campaign=${
                                            layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                          }`,
                                      '_blank',
                                    );
                                  }
                                }
                              }}
                              className="zid-rounded zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zIdkBtnPrdTagMain"
                              dangerouslySetInnerHTML={{
                                __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop',
                              }}
                            ></button>
                          )}
                        </idk-div>
                      </idk-div>
                    </idk-div>
                  </idk-div>
                  {layout?.productsSettings?.shopBtnPosition == 'bottom' && (
                    <button
                      ref={btnTwoRef.current[index]}
                      onClick={() => {
                        if (isOpen) {
                          clickMutate(row.id, {
                            event: 'add_to_cart',
                            price: product?.variants?.[0]?.salePrice,
                            productId: product?.id_from_product,
                          });
                          setSelectedProduct(product);
                          setProductOverlayIndex(index);
                        } else {
                          const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                          if (shopBtnFunctionality) {
                            try {
                              const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                              func(row, product, btnTwoRef.current[index]);
                            } catch (error) {
                              console.error('Error executing shopBtnFunctionality', error);
                            }
                          } else {
                            window.open(
                              shopifyData
                                ? `https://${window.location.host}/products/${product?.handle}`
                                : `${product?.product_url}?utm_source=${
                                    layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                  }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                    layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                  }`,
                              '_blank',
                            );
                          }
                        }
                      }}
                      style={{ borderRadius: '0 0 5px 5px' }}
                      className="zid-cursor-pointer zid-h-14 zid-w-full zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zIdkBtnPrdTagMain"
                      dangerouslySetInnerHTML={{ __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop' }}
                    ></button>
                  )}
                </SwiperSlide>
              );
            })}
        </Swiper>
      </idk-div>
      {isOpen && (width <= 600 || data.result.layout.galleryView === 'frame') && (
        <SpecialProductMobileOverlay
          isOpen={isOpen}
          row={row}
          product={selectedProduct}
          setProduct={setSelectedProduct}
          shopifyData={shopifyData}
          albumData={albumData}
          activeIndex={activeIndex}
        />
      )}
      {/* {(width <= 600 || data.result.layout.galleryView === 'frame') && (
        <ProductMobileOverlay
          isOpen={isOpen}
          product={selectedProduct}
          setProduct={setSelectedProduct}
          shopifyData={shopifyData}
        />
      )} */}
    </React.Fragment>
  );
}
